import { Box, Dialog, Grid } from "@mui/material";
import { useEffect, useState } from "react";


import * as yup from "yup";
import { Field, Form, Formik } from "formik";
import { mixed, number, string } from "yup";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import { EditMailingPermitCommand, MailingPermit } from "../../../api/models/schema";
import { StandardTextBox } from "../../../common/standardTextBox";
import { StandardDropDown } from "../../../common/standardDropDown";

const mailPayMethodDropDownItem = [
  { id: "IMPRINT", name: "IMPRINT" },
  { id: "METER", name: "METER" },
  { id: "STAMP", name: "STAMP" }
];


export interface FormValues {
  permitNumber: string;
  customerRegistrationId: string;
  intelligentBarCodeMailerId: string;
  name: string;
  companyName: string;
  addressLine1: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
  nonProfitAuthorizationNumber: string;
  mailPayMethod:string;
  netPostageDuePermitNumber:string;
}

const validationSchema = yup.object({
  name: string().min(3, "too short").required("required"),
  //customerRegistrationId: mixed().required("required"),
  //intelligentBarCodeMailerId: mixed().required("required"),
  companyName: string().required("required"),
  addressLine1: string().required("required"),
  city: string().required("required"),
  state: string().required("required"),
  //zip: string().required("required"),
  //phone: string().required("required"),
});

export interface EditMailingPermitFormProps {
  mailingPermit?: MailingPermit;
  userName?: string;
  open: boolean;
  mailingPermitError: string;
  mailOwnerClientId?:number;
  clientId?:number;
  onClose: () => void;
  onUpdate: (org: EditMailingPermitCommand) => void;
}

export function EditMailingPermitForm(props: EditMailingPermitFormProps) {
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (props.mailingPermitError) {
      setErrorMessage(props.mailingPermitError);
      setIsLoading(false);
    }
  }, [props.mailingPermitError]);

  useEffect(() => {
    if (props.open) {
      setIsLoading(false);
    }
  }, [props.open]);

  function update(values: FormValues) {
    const updateOrg: EditMailingPermitCommand = {
      permitNumber: values.permitNumber,
      customerRegistrationId: values.customerRegistrationId,
      intelligentBarCodeMailerId: values.intelligentBarCodeMailerId,
      name: values.name,
      companyName: values.companyName,
      addressLine1: values.addressLine1,
      city: values.city,
      state: values.state,
      zip: values.zip,
      phone: values.phone,
      nonProfitAuthorizationNumber: values.nonProfitAuthorizationNumber,
      mailPayMethod:values.mailPayMethod,
      netPostageDuePermitNumber:values.netPostageDuePermitNumber

    };

    setIsLoading(true);
    props.onUpdate(updateOrg);
  }

  function handleClose() {
    setIsLoading(false);
    props.onClose();
  }

  function displayForm() {
    return (
      <Box>
        <Dialog open={props.open}>
          <DialogTitle>Edit Mailing Info</DialogTitle>
          <DialogContent>
            <Formik
              initialValues={
                props.mailingPermit
                  ? {
                      permitNumber: props.mailingPermit.permitNumber,
                      customerRegistrationId:
                        props.mailingPermit.customerRegistrationId,
                      intelligentBarCodeMailerId:
                        props.mailingPermit.intelligentBarCodeMailerId,
                      name: props.mailingPermit.name,
                      companyName: props.mailingPermit.companyName,
                      addressLine1: props.mailingPermit.addressLine1,
                      city: props.mailingPermit.city,
                      state: props.mailingPermit.state,
                      zip: props.mailingPermit.zip,
                      phone: props.mailingPermit.phone,
                      nonProfitAuthorizationNumber:props.mailingPermit.nonProfitAuthorizationNumber,
                      mailPayMethod:props.mailingPermit.mailPayMethod,
                      netPostageDuePermitNumber:props.mailingPermit.netPostageDuePermitNumber
                    }
                  : {
                      permitNumber: "",
                      customerRegistrationId: "",
                      intelligentBarCodeMailerId: "",
                      name: "",
                      companyName: "",
                      addressLine1: "",
                      city: "",
                      state: "",
                      zip: "",
                      phone: "",
                      nonProfitAuthorizationNumber:"",
                      mailPayMethod:"IMPRINT",
                      netPostageDuePermitNumber:""
                    }
              }
              validationSchema={validationSchema}
              onSubmit={(values, { setSubmitting }) => {
                setSubmitting(false);
                update(values);
              }}
            >
              {({ submitForm, setFieldValue, isSubmitting }) => (
                <Form>
                  <br />

                  <Grid container spacing={2}>
                    <Grid item xs={3}>
                      Permit Number
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="permitNumber"
                        label="Permit Number"
                        width={375}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      Permit Name
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="name"
                        label="Permit Name"
                        width={375}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      Company Name
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="companyName"
                        label="Company Name"
                        width={375}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      CRID
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="customerRegistrationId"
                        label="Customer Registration Id"
                        width={375}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      IMBD
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="intelligentBarCodeMailerId"
                        label="Intelligent BarCode Mailer Id"
                        width={375}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      Non Profit #
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="nonProfitAuthorizationNumber"
                        label="Non Profit #"
                        width={375}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      Mail Pay Method
                    </Grid>
                    <Grid item xs={9}>
                    <Field
                        component={StandardDropDown}
                        name="mailPayMethod"
                        label="Mail Pay Method"
                        items={mailPayMethodDropDownItem}
                        width={375}
                        onChange={(e: any) => {
                          setFieldValue("mailPayMethod", e.target.value);
                        }}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      Postage Due Permit #
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="netPostageDuePermitNumber"
                        label="Postage Due Permit #"
                        width={375}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      Address
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="addressLine1"
                        label="Address"
                        width={375}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      City
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="city"
                        label="city"
                        width={375}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      State
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="state"
                        label="State"
                        width={375}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      Zip
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="zip"
                        label="Zip"
                        width={375}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      Phone
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="phone"
                        label="Phone"
                        width={375}
                      />
                    </Grid>

                    <Grid
                      spacing={2}
                      item
                      container
                      xs={12}
                      justifyContent="flex-end"
                    >
                      {!isLoading && (
                        <Grid item>
                          <Button variant="contained" onClick={submitForm}>
                            Save
                          </Button>
                        </Grid>
                      )}
                      {isLoading && (
                        <Grid item>
                          <CircularProgress />
                        </Grid>
                      )}
                      <Grid item>
                        <Button onClick={handleClose}>Cancel</Button>
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      {errorMessage && <p>{errorMessage}</p>}
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      </Box>
    );
  }

  return <>{displayForm()}</>;
}
